import { createCustomTheme } from '@domains/subscription/theme'
import { ThemeProvider } from '@mui/material'
import type { BureauFeatures } from '../api/api'
import { useBureauFeatures, useUpdateBureauFeatures } from '../api/queries'
import { BureauFeatureToggle } from '../usecases/BureauFeatureToggle'

interface BureauFeaturesFactoryProps {
  customerId: string
  onChange?: () => void
}

export const BureauFeaturesFactory = ({ customerId, onChange }: BureauFeaturesFactoryProps) => {
  const { data: features, isFetching: isLoadingBureauFeatures, isError: isErrorBureauFeatures } = useBureauFeatures(customerId)
  const { mutate, isLoading: isPathcingBureauFeatures } = useUpdateBureauFeatures(customerId)

  const handleToggle = (features: BureauFeatures) => {
    mutate(features, {
      onSuccess: () => onChange?.(),
    })
  }

  const isLoading = isLoadingBureauFeatures || isPathcingBureauFeatures

  return (
    <ThemeProvider theme={createCustomTheme()}>
      <BureauFeatureToggle value={features} onToggle={handleToggle} isLoading={isLoading} isError={isErrorBureauFeatures} />
    </ThemeProvider>
  )
}
